<template>
  <el-dialog
    :title="type === 1?'上传头像':'上传社区照片'"
    :visible.sync="imgDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center>
    <el-form :model="fileForm" :rules="rules" ref="fileForm">

      <el-form-item prop="name">
        <div class="flex align-center justify-around">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            accept="image/*"
            :action="upUrl + '/Index/Other/upload'"
            :name="'image'"
            :data="fileData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <el-image
              class="avatar"
              :class="{active:type === 2}"
              v-if="imageUrl"
              :src="imageUrl"
              fit="contain"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>

      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('fileForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('fileForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {ONLINEHOST, QAHOST} from "@/config";
import {addImage} from "@/api/common";

export default {
  name: "imgDialog",
  props: {
    imgDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
      imageUrl: '',
      limit: 1,
      fileForm: {
        url: '',
      },
      rules: {
        url: [{required: true, message: '请选择图片', trigger: 'change'}]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    fileData() {
      return {
        token: this.user.token,
        addWatermark: 0
      };
    },
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs['upload'].clearFiles()
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await addImage(
        this.setId,
        this.type,
        this.fileForm.url,
      );
      this.$message.success(_state.info);
      this.imageUrl = ''
      this.$refs[formName].resetFields();
      this.$refs['upload'].clearFiles()

      this.$emit("cancelDialog", true);
    },
    //  上传成功
    handleAvatarSuccess(res, file) {
      console.log(res)
      if (res.status === 200) {
        this.imageUrl = this.upUrl + '/' + res.data
        this.fileForm.url = res.data
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
  },
  watch: {
    setItem() {
      this.imageUrl = ''
      if(this.type === 1){
        this.fileForm = {
          url: this.setItem.avatar
        };
        if(this.setItem.avatar){
          this.imageUrl = this.upUrl + '/' + this.setItem.avatar
        }
      }else{
        this.fileForm = {
          url: this.setItem.images
        };
        if(this.setItem.images){
          this.imageUrl = this.upUrl + '/' + this.setItem.images
        }
      }

    }
  }
}
</script>

<style scoped lang="scss">
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  display: block;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 180px;
  display: block;
  border: 1px dashed #d9d9d9;
  &.active{
    width: 400px;
    height: 300px;
  }
}
</style>
